import { atom } from "jotai";
import { Chat, ChatWithMessages } from "../types/chat";

// 인증 상태
export const authAtom = atom({
  isLoggedIn: false,
  accessToken: null as string | null,
  isInitialized: false, // 초기화 완료 여부
});

// 사용자 정보 상태
export const userAtom = atom({
  id: null as string | null,
  name: "",
  email: "",
});

// 로딩 상태
export const loadingAtom = atom(false);

// 네비게이션 상태
export const activeTabAtom = atom("수산");

// 채팅 관련 상태
export const chatsAtom = atom<Chat[]>([]);

export const currentChatAtom = atom<ChatWithMessages | null>(null);

export const chatMessageAtom = atom("");

export const chatLoadingAtom = atom(false);

export const chatListLoadingAtom = atom(false);

// 스트리밍 관련 상태
export const isStreamingAtom = atom(false);

export const streamingContentAtom = atom("");

// 익명 채팅 메시지 상태
export const anonymousMessagesAtom = atom<
  Array<{
    id: string;
    role: "USER" | "AI";
    content: string;
    timestamp: string;
  }>
>([]);

// UI 상태
export const sidebarOpenAtom = atom(false);

export const searchQueryAtom = atom("");

// 에러 상태
export const errorAtom = atom<{
  message: string;
  type: "error" | "warning" | "info";
} | null>(null);
